import { Pipe, PipeTransform } from "@angular/core";
import { DomSanitizer } from "@angular/platform-browser";
import { icons } from "feather-icons";


@Pipe({ name: "feather" })
export class FeatherIconsPipe implements PipeTransform {

    constructor(private readonly sanitizer: DomSanitizer) { }

    transform(icon: string, size = 24, className: string, color = "inherit") {
        return this.sanitizer.bypassSecurityTrustHtml(icons[icon].toSvg({
            width: size,
            height: size,
            color: color,
            "class": className
        }));
    }
}